import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10 p-8 md:p-12 lg:p-14">
            <div className="w-full lg:w-1/2 flex flex-col gap-5">
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {appData.desc}
              </p>

              <div className="grid grid-cols-2 gap-3">
                {appData.features.map((feat, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-check-line text-xs"></i>
                    </div>
                    <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">{feat}</span>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-3 flex-wrap pt-1">
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-apple-line"></i> App Store
                </a>
                <a
                  href="#app"
                  onClick={(e) => e.preventDefault()}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-android-line"></i> Google Play
                </a>
              </div>
            </div>

            <div className="w-full lg:w-1/2 flex items-center justify-center">
              <div className="relative w-full max-w-[360px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20reading%20app%20interface%20with%20Japanese%20comic%20art%20thumbnails%2C%20warm%20coral%20accent%20UI%20design%2C%20clean%20modern%20mobile%20app%20screenshot%2C%20floating%20above%20soft%20background&width=720&height=1280&seq=app-manga-mobile&orientation=portrait"
                  alt="新新漫画移动客户端 - 高清漫画在线阅读App"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}